<template>
  <div class="about">
    <h1>Oops we can't find what you're looking for</h1>
  </div>
</template>
